import React from "react";
import {
  ArrowRight,
  BookOpen,
  CalendarDays,
  Map,
  ShoppingBag,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const MODULES = [
  {
    title: "Mapa huertero",
    eyebrow: "Territorio",
    description: "Recorra huertas, pacas urbanas e iniciativas que ya están polinizando Medellín.",
    action: "Explora el mapa",
    path: "/mapa",
    icon: Map,
    surfaceClass: "from-[#DDEECC] to-[#BFD8AE]",
  },
  {
    title: "Agenda viva",
    eyebrow: "Calendario",
    description: "Encuentre talleres, recorridos, mingas, encuentros y eventos.",
    action: "Ver la agenda",
    path: "/calendario",
    icon: CalendarDays,
    surfaceClass: "from-[#E8F0D1] to-[#C7D8A1]",
  },
  {
    title: "Economía local",
    eyebrow: "Directorio",
    description: "Conecte con productos, servicios e intercambios que hacen circular el polen comunitario.",
    action: "Abrir directorio",
    path: "/directorio",
    icon: ShoppingBag,
    surfaceClass: "from-[#DCECD8] to-[#B5D0AC]",
  },
  {
    title: "Saberes vivos",
    eyebrow: "Conocimiento",
    description: "Entre al foro y a la biblioteca para compartir materiales, preguntas y experiencias.",
    action: "Entrar a saberes",
    path: "/conocimiento",
    icon: BookOpen,
    surfaceClass: "from-[#E7EED5] to-[#C6D7A5]",
  },
];

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-7xl p-6">
      <section className="platform-elevated-surface rounded-[34px] border p-6">
        <div className="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-primary/70">Recorrido polénico</p>
            <h2 className="mt-2 font-heading text-3xl font-semibold text-primary">Siga el rastro del polen</h2>
            <p className="mt-2 text-sm leading-6 text-mutedForeground">Toque una tarjeta para continuar.</p>
          </div>
          <div className="platform-soft-chip rounded-full border px-4 py-2 text-sm font-medium text-primary/80">
            Mapa, calendario, directorio y conocimiento
          </div>
        </div>

        <div className="mt-6 grid gap-5 md:grid-cols-2 xl:grid-cols-4">
          {MODULES.map((module) => {
            const Icon = module.icon;

            return (
              <button
                key={module.path}
                type="button"
                onClick={() => navigate(module.path)}
                className={`group overflow-hidden rounded-[30px] border border-primary/10 bg-gradient-to-br ${module.surfaceClass} p-5 text-left shadow-[0_16px_34px_rgba(43,67,44,0.08)] transition hover:-translate-y-1 hover:shadow-[0_24px_46px_rgba(40,61,41,0.15)]`}
              >
                <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-primary/68">{module.eyebrow}</p>
                <div className="mt-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#F7FBF4]/86 text-primary shadow-sm">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-5 font-heading text-2xl font-semibold text-primary">{module.title}</h3>
                <p className="mt-3 text-sm leading-7 text-mutedForeground">{module.description}</p>
                <div className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary">
                  {module.action}
                  <ArrowRight className="h-4 w-4 transition group-hover:translate-x-0.5" />
                </div>
              </button>
            );
          })}
        </div>
      </section>
    </div>
  );
}
